<template>
    <div class="p-3">
        <el-card header="Lojas cadastradas">

            <el-row class="py-2">
                <h5 class="v-col-6 v-col-md-9 me-3">Pesquisar</h5>
                <div class="v-col-6 v-col-md-3">
                    <el-radio-group v-model="searchType">
                        <el-radio value="string" border>por nome</el-radio>
                        <el-radio value="number" border>Pelo codigo</el-radio>
                    </el-radio-group>
                </div>
                <div class="v-col-6 v-col-md-3 ms-2">
                    <el-select v-model="status" placeholder="Estados" style="width: 240px">
                        <el-option
                            v-for="item in states"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </div>
            </el-row>
            <ElRow class="pb-5" v-if="searchType == 'string'">
                <ElInput type="search" name="q" style="flex: 1" v-model="q" class="mx-1" placeholder="Procurar produtos" />
                <ElButton :loading="loading" @click="() => getStores(q)">
                    <ElIcon>
                        <Search />
                    </ElIcon>
                </ElButton>
            </ElRow>
            <ElRow class="pb-5" v-else>
                <ElInput type="number" name="cod" v-model="cod" style="flex: 1" class="mx-1" placeholder="Digite o codigo do produto" />
                <ElButton :disabled="cod ? false:true" :loading="loading" @click="() => getStore(cod)">
                    <ElIcon>
                        <Search />
                    </ElIcon>
                </ElButton>
            </ElRow>

            <PaginatedTable :loading="loading" :page="data.current_page" :show-rows="10" :pages="data.last_page" :data="data.data.filter((store) => store.id != 1)" :cols="[
                {label: 'Cod', prop: 'id'},
                {label: 'Nome', prop: 'name'},
                {label: 'Localização', prop: 'location'},
                {label: 'Contacto', prop: 'phone'},
                {label: 'Email', prop: 'email'},
                {label: 'Tipo de produto', prop: 'category'},
            ]" @change="changePage">
                <el-table-column label="Dono da loja" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.user?.name }} ({{ data.row.user?.phone }})
                    </template>
                </el-table-column>
                <el-table-column label="Acções" class-name="auto" :min-width="150">
                    <template #default="data">
                        <span class="p-2">
                            <el-button type="primary" tag="router-link" :to="'/stores/' + data.row.id" icon="View" title="Ver mais"></el-button>
                        </span>
                        <span class="p-2" v-if="!data.row.approved_at">
                            <el-button :loading="data.row.loading" @click="() => approve(data.row)" type="warning" icon="RemoveFilled" title="Desativar"></el-button>
                        </span>
                        <span class="p-2" v-else>
                            <el-button :loading="data.row.loading" @click="() => disapprove(data.row)" type="success" title="Activavar" icon="Select"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PaginatedTable>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElButton, ElIcon, ElInput, ElMessage, ElMessageBox, ElRow } from 'element-plus';
    import { useStore } from 'vuex';
    import PaginatedTable from '@/components/PaginatedTable.vue';
    import { Paginated } from '@/services/types/paginated';
    import { defaultPaginated } from '@/utilities/helpers';
    import { Store } from '@/services/types/store';

    const loading = ref<boolean>(true)
    const data = ref<Paginated<Store>>(defaultPaginated)
    const q = ref<string>('')
    const status = ref<'approved' | 'blocked'| 'all'>('all')
    const states = ref<{value: string, label: string}[]>([
        {value: 'approved', label: 'Aprovadas'},
        {value: 'blocked', label: 'Nao aprovadas'},
        {value: 'all', label: 'Todas'},
    ])
    const searchType = ref<'string' | 'number'>('string')
    const cod = ref<number>()

    const getStores = async (q = '', page = 1) => {
        console.log("Okay")
        loading.value = true
        const res = await Api.get(`admin/stores?q=${q}&page=${page}&status=${status.value}`)
        if (res.status == 200) {
            data.value = res.data.stores
            console.log(res.data.stores)
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
        loading.value = false
    }
    
    const getStore = async (id: number | undefined) => {
        if (!id || id <= 0) {
            getStores()
        } else {
            loading.value = true
            data.value.last_page = 1
            data.value.current_page = 1
            const res = await Api.get('admin/stores/' + id)
            if (res.status == 200) {
                data.value.data = [res.data.store]
            } else {
                ElMessageBox.alert('Não foi encontrado nenhuma loja com este código')
                data.value.data = []
            }
            loading.value = false
        }
    }

    const changePage = (page: number) => {
        getStores(q.value, page)
    }

    onBeforeMount(() => {
        getStores()
    })

    const vuex = useStore()
    vuex.watch((state, getter) => getter.openModal, async (val, oldVal) => {
        if (oldVal == 2) {
            // new product
            await getStores()
        }
    })

    const approve = async (row: any) => {
        row.loading = true
        const res = await Api.post(`admin/stores/${row.id}`, {})
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: row.name + ' Actualizado com sucesso'})
            row.approved_at = res.data.store.approved_at
        }
        row.loading = false
    }

    const disapprove = async (row: any) => {
        row.loading = true
        const res = await Api.delete(`admin/stores/${row.id}`)
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: row.name + ' Actualizado com sucesso'})
            row.approved_at = res.data.store.approved_at
        }
        row.loading = false
    }
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
